import { Tracing } from 'trace_events'
import { baseApi } from './baseApi'

export const gradebookAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_gradebookGrid: builder.query<any, {group_course: string, params: any}>({
      query: ({group_course, params}) => ({
        url: `/gradebook-grid/${group_course}/`,
        params,
      }),
      providesTags: ['gradebook-grid'],
    }),

    GET_gradebookGridSummary: builder.query<any, {academic_year: string, grade_level: string, params: any}>({
      query: ({academic_year, grade_level, params}) => ({
        url: `/gradebook-grid-summary/${academic_year}/${grade_level}/`,
        params,
      }),
      providesTags: ['gradebook-grid'],
    }),
    GET_gradebookGridAssignments: builder.query<any, {group_course: string, params: any}>({
      query: ({group_course, params}) => ({
        url: `/gradebook-grid-assignments/${group_course}/`,
        params,
      }),
      providesTags: ['gradebook-grid-assignments'],
    }),
    GET_gradebookGridStudent: builder.query<any, {student_id: string, academic_year: string, params: any}>({
      query: ({student_id, academic_year, params}) => ({
        url: `/gradebook-grid-student/${student_id}/${academic_year}/`,
        params,
      }),
      providesTags: ['gradebook-grid-student'],
    }),
    POST_gradebookReportView: builder.mutation<any, any>({
      query: ({academic_year, grade_level, student_id}) => ({
        url: `/gradebook-grid-summary/${academic_year}/${grade_level}/?student_id=${student_id}`,
        method: 'POST',
      }),
    }),
    POST_gradebookReportSendStudent: builder.mutation<any, any>({
      query: ({academic_year, grade_level, student_id}) => ({
        url: `/gradebook-grid-summary/${academic_year}/${grade_level}/?student_id=${student_id}&send_report_to=student`,
        method: 'POST',
      }),
    }),
    POST_gradebookReportSendParents: builder.mutation<any, any>({
      query: ({academic_year, grade_level, student_id}) => ({
        url: `/gradebook-grid-summary/${academic_year}/${grade_level}/?student_id=${student_id}&send_report_to=parents`,
        method: 'POST',
      }),
    }),

  }),
})

export const { 
  useGET_gradebookGridQuery, 
  useGET_gradebookGridAssignmentsQuery, 
  useGET_gradebookGridStudentQuery, 
  useGET_gradebookGridSummaryQuery,
  usePOST_gradebookReportViewMutation, 
  usePOST_gradebookReportSendStudentMutation, 
  usePOST_gradebookReportSendParentsMutation, 
} = gradebookAPI
